//@flow
export const CREATE_REQUESTED = "subscriptions/CREATE_REQUESTED";
export const CREATE_COMPLETED = "subscriptions/CREATE_COMPLETED";
export const CREATE_FAILED = "subscriptions/CREATE_FAILED";

export const DELETE_REQUESTED = "subscriptions/DELETE_REQUESTED";
export const DELETE_COMPLETED = "subscriptions/DELETE_COMPLETED";
export const DELETE_FAILED = "subscriptions/DELETE_FAILED";

export const FETCH_LIST_REQUESTED = "subscriptions/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "subscriptions/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "subscriptions/FETCH_LIST_FAILED";

export const FETCH_DETAILS_REQUESTED = "subscriptions/FETCH_DETAILS_REQUESTED";
export const FETCH_DETAILS_COMPLETED = "subscriptions/FETCH_DETAILS_COMPLETED";
export const FETCH_DETAILS_FAILED = "subscriptions/FETCH_DETAILS_FAILED";

export const RESET_LIST = "subscriptions/RESET_LIST";
